import { queryKeys } from "@/lib/queryKeys";
import { useServiceContext } from "@cs_teamwaydev/mailvista-sdk_react";
import { useQuery } from "@tanstack/react-query";

const useGetUserAvatar = (email: string) => {
    const userManager = useServiceContext().sdk?.userManager;

    const getUserAvatar = async () => {
        if (!userManager) {
            throw new Error("userManager or email is not defined");
        }

        try {
            const photoUrl = await userManager.getUserPhotoByEmail(email);

            const response = await fetch(photoUrl);
            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);

            return objectUrl;
        } catch (error) {
            console.error("Error fetching user avatar:", error);

            return null;
        }
    };

    const userAvatar = useQuery({
        queryKey: queryKeys.user.avatar(email),
        queryFn: getUserAvatar,
        enabled: Boolean(email),
    });

    return userAvatar;
};

export default useGetUserAvatar;
